import { fetchRewardSectionLists } from '~/api/promo'
import type { RewardSectionItemDto } from '~/types/api/promo'

/**
 * GET /rewards/section-lists：奖励中心导航页签 + 领取记录筛选，后端下发。
 * useState 跨组件共享，loaded 去重；失败时保持空，不再本地兜底。
 */
export function useRewardSectionLists() {
  const nav = useState<RewardSectionItemDto[]>('reward-section-nav', () => [])
  const recordFilter = useState<RewardSectionItemDto[]>('reward-section-record-filter', () => [])
  const loaded = useState('reward-section-loaded', () => false)

  const load = async () => {
    if (loaded.value) return
    loaded.value = true
    try {
      const res = await fetchRewardSectionLists()
      if (res.reward_nav?.length) nav.value = res.reward_nav
      if (res.reward_record_filter?.length) recordFilter.value = res.reward_record_filter
    } catch (e) {
      // 拦截器已 toast；失败时保持空，页签/筛选不渲染
      console.error('[rewards] fetch section-lists failed:', e)
    }
  }

  onMounted(() => {
    void load()
  })

  return { nav, recordFilter, load }
}
